/** Clé sessionStorage : limite les rechargements auto après échec de chunk. */
const CHUNK_RELOAD_ATTEMPTS_KEY = "cliently:chunk-reload-attempts";

const MAX_AUTO_RELOAD_ATTEMPTS = 2;

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Loading chunk [\w-]+ failed/i,
  /Loading CSS chunk [\w-]+ failed/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
  /MIME type.*text\/html/i,
];

/** Erreur typique quand un chunk Vite a été supprimé après un nouveau déploiement. */
export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "";
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

/** Recharge la page une ou deux fois max pour récupérer le nouveau index.html. */
export function reloadAfterDeployOnce(): void {
  const attempts = Number(
    sessionStorage.getItem(CHUNK_RELOAD_ATTEMPTS_KEY) ?? "0",
  );
  if (attempts >= MAX_AUTO_RELOAD_ATTEMPTS) return;

  sessionStorage.setItem(
    CHUNK_RELOAD_ATTEMPTS_KEY,
    String(attempts + 1),
  );
  window.location.reload();
}

/** Réinitialise le compteur après un chargement réussi du bundle principal. */
export function resetChunkReloadAttempts(): void {
  sessionStorage.removeItem(CHUNK_RELOAD_ATTEMPTS_KEY);
}

/**
 * Écoute les échecs de chargement de chunks (preload Vite + import() dynamique)
 * et recharge automatiquement pour récupérer la version déployée.
 */
export function registerChunkLoadRecovery(): void {
  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    reloadAfterDeployOnce();
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (!isChunkLoadError(event.reason)) return;
    event.preventDefault();
    reloadAfterDeployOnce();
  });
}
